export default __webpack_public_path__ + "static/media/W.ffa26485.svg";